
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"18","viewBox":"0 0 20 18","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.923 1.543a2.311 2.311 0 00-2.308 2.314 2.311 2.311 0 002.308 2.314 2.311 2.311 0 002.308-2.314 2.311 2.311 0 00-2.308-2.314zM3.077 3.857A3.852 3.852 0 016.923 0a3.852 3.852 0 013.846 3.857 3.852 3.852 0 01-3.846 3.857 3.852 3.852 0 01-3.846-3.857z"}}),_c('path',{attrs:{"d":"M0 3.857a.77.77 0 01.77-.771h3.076a.77.77 0 010 1.543H.77A.77.77 0 010 3.857zm9.23 0a.77.77 0 01.77-.771h9.23a.77.77 0 010 1.543H10a.77.77 0 01-.77-.772zm3.847 7.972a2.311 2.311 0 012.308 2.314 2.311 2.311 0 01-2.308 2.314 2.311 2.311 0 01-2.308-2.314 2.311 2.311 0 012.308-2.315zm3.846 2.314a3.852 3.852 0 00-3.846-3.857 3.852 3.852 0 00-3.846 3.857A3.852 3.852 0 0013.077 18a3.852 3.852 0 003.846-3.857z"}}),_c('path',{attrs:{"d":"M20 14.143a.77.77 0 00-.77-.772h-3.076a.77.77 0 000 1.543h3.077a.77.77 0 00.769-.771zm-9.23 0a.77.77 0 00-.77-.771H.77a.77.77 0 000 1.542H10a.77.77 0 00.77-.771z"}})])
          )
        }
      }
    